module.exports = __webpack_public_path__ + "static/assets/d4f6fe9928fb15fec455cb765b50a434.jpg";